import React from 'react';
import PropTypes from 'prop-types';
import PlayItv from '../CallToActions/PlayItv';
import {
    RacingButtonLinkWrapper,
    FootballButtonLinkWrapper,
    Itv7FootballTermsLinkWrapper
} from '../LinkWrappers';

const RACING_TEXT =
    'Predict 7 winning horses for a chance to win huge cash prizes!';
const FOOTBALL_TEXT =
    'Predict 7 correct outcomes within a match to win cash prizes!';

const CrossPromoCards = ({ currentSport, buttonText, TermsLink }) => {
    const racingCard = (
        <PlayItv
            titleText={RACING_TEXT}
            buttonText={buttonText}
            TermsLink={TermsLink}
            ButtonLink={RacingButtonLinkWrapper}
            sportType="racing"
        />
    );
    const footballCard = (
        <PlayItv
            titleText={FOOTBALL_TEXT}
            buttonText={buttonText}
            TermsLink={Itv7FootballTermsLinkWrapper}
            ButtonLink={FootballButtonLinkWrapper}
            sportType="football"
        />
    );

    return currentSport === 'football' ? (
        <>
            {footballCard}
            {racingCard}
        </>
    ) : (
        <>
            {racingCard}
            {footballCard}
        </>
    );
};

CrossPromoCards.propTypes = {
    currentSport: PropTypes.oneOf(['racing', 'football']).isRequired,
    buttonText: PropTypes.string.isRequired,
    TermsLink: PropTypes.func.isRequired
};

export default CrossPromoCards;
